// Console EvilDog (red-team / lab). pt e en migrados do dicionário original;
// es e it preenchidos na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
const evildog = {
  pt: {
    'evd.subtitle': 'RECON_SUITE · só lab · dados sintéticos',
    'evd.internet': 'internet', 'evd.internal': 'interno',
    'evd.telemetry_live': 'telemetria ao vivo', 'evd.offline': 'offline',
    'evd.tab_control': 'Painel', 'evd.tab_orchestrator': 'Orquestrador', 'evd.tab_postexploit': 'Pós-Exploração',
    'evd.maximize': 'Maximizar', 'evd.restore': 'Restaurar (Esc)',
    'evd.footer': 'EvilDog opera apenas contra os serviços do laboratório DogBank · uso educacional / EBC',
    'evd.rotate_ip': 'Rotacionar IP', 'evd.source_ip': 'IP de origem',
    'evd.rotate_hint': 'Gera um novo IP de origem (X-Forwarded-For) para evadir bloqueios da AAP',
    'evd.targets': 'Alvos', 'evd.target_ph': 'host / IP (ex: 10.0.0.5)', 'evd.lab_only': 'Somente alvos do lab (allowlist).',
    'evd.scope_err': 'target fora do escopo',
    'evd.orch_subtitle': 'Fluxo ativo: pipeline de SQL Injection (emulação de ataque ao vivo)',
    'evd.run_pipeline': 'RODAR PIPELINE', 'evd.running': 'RODANDO…',
    'evd.new_take': 'NOVO TAKE', 'evd.preparing_take': 'PREPARANDO…',
    'evd.st_completed': 'COMPLETO', 'evd.st_running': 'EXECUTANDO', 'evd.st_idle': 'OCIOSO', 'evd.st_blocked': 'PIPELINE FAIL',
    'evd.legend_title': 'Legenda de cores do fluxo',
    'evd.legend_recon': 'Recon & Descoberta', 'evd.legend_vuln': 'Verificação de Vuln', 'evd.legend_payload': 'Montagem de Payload',
    'evd.legend_exploit': 'Exploração Ativa', 'evd.legend_final': 'Exfil & Final',
    'evd.feed_title': 'Feed de telemetria ao vivo', 'evd.feed_empty': '// sem eventos — clique em RODAR PIPELINE',
    'evd.records_exfil': 'registros exfiltrados', 'evd.secrets': 'segredos',
    'evd.see_postexploit': 'ver a aba Post-Exploit para o loot completo',
    'evd.pe_inside': 'Você está dentro.',
    'evd.pe_desc': 'Escolha as ações de pós-exploração — elas executam de verdade contra o lab (PIX real, dump de dados, extração de segredos).',
    'evd.pe_console': 'Post-Exploit Console · sessão ativa', 'evd.pe_inside_tag': 'dentro do sistema',
    'evd.pe_report_title': 'Relatório do que foi roubado',
    'evd.col_name': 'Nome', 'evd.col_cpf': 'CPF', 'evd.col_pass': 'Senha', 'evd.col_balance': 'Saldo', 'evd.col_bank': 'Banco', 'evd.col_pixkey': 'Chave PIX',
    'evd.col_mfa': 'MFA', 'evd.mfa_on': 'protegida', 'evd.mfa_off': 'sem MFA',
    'evd.reveal': 'revelar', 'evd.mask': 'mascarar', 'evd.refresh': 'atualizar',
    'evd.esc_fail_title': 'PIPELINE FAIL',
    'evd.esc_blocked_msg': 'a pipeline falhou no início. Escale os agentes para outros IPs:',
    'evd.esc_change_ip': 'Trocar IP', 'evd.esc_escalate': 'Escalar agentes',
    'evd.esc_blocked': 'BLOQUEADO', 'evd.esc_ok': 'OK',
    'evd.esc_contained': '🛡️ CONTIDO',
    'evd.agent_attack_failed': 'FAIL · ATAQUE CONTIDO',
    'evd.swarm_title': 'Enxame de agentes reais · Jobs no Kubernetes',
    'evd.swarm_title_docker': 'Enxame de agentes reais · containers efêmeros',
    'evd.pods': 'pods',
    'evd.agents': 'agentes',
    'evd.esc_real_hint': 'cada agente escalado é um Pod Kubernetes real (Job efêmero) — não é uma animação',
    'evd.esc_swarm_size': 'Tamanho do enxame',
    'evd.pod_ticker_title': 'Eventos do cluster (ao vivo)',
    'evd.pod_stat_pending': 'Pendentes',
    'evd.pod_stat_running': 'Em execução',
    'evd.pod_stat_succeeded': 'Concluídos',
    'evd.pod_stat_failed': 'Falharam',
    'evd.pod_stopped_at': 'travou em',
    'evd.pod_reached': 'chegou até',
    'evd.pod_reaped': 'pod recolhido',
    'evd.pod_no_outcome': 'sem desfecho',
    'evd.pod_no_stage': 'não iniciou nenhum estágio',
    'evd.swarm_report_title': 'Relatório da rodada',
    'evd.swarm_rerun': 'Rodar enxame',
    'evd.swarm_close': 'Fechar painel',
    'evd.esc_err_cooldown': 'Aguarde o cooldown do backend:',
    'evd.esc_err_capacity': 'Limite de agentes simultâneos atingido — aguarde a rodada atual terminar.',
    'evd.esc_err_forbidden': 'Sessão ou token do operador inválido — escalação recusada.',
    'evd.esc_err_unavailable': 'Orquestração de agentes indisponível (sem Kubernetes nem Docker).',
    'evd.esc_err_generic': 'Falha ao escalar:',
  },
  es: {
    'evd.subtitle': 'RECON_SUITE · solo lab · datos sintéticos',
    'evd.internet': 'internet', 'evd.internal': 'interno',
    'evd.telemetry_live': 'telemetría en vivo', 'evd.offline': 'offline',
    'evd.tab_control': 'Panel', 'evd.tab_orchestrator': 'Orquestador', 'evd.tab_postexploit': 'Post-Explotación',
    'evd.maximize': 'Maximizar', 'evd.restore': 'Restaurar (Esc)',
    'evd.footer': 'EvilDog opera solo contra los servicios del laboratorio DogBank · uso educativo / EBC',
    'evd.rotate_ip': 'Rotar IP', 'evd.source_ip': 'IP de origen',
    'evd.rotate_hint': 'Genera una nueva IP de origen (X-Forwarded-For) para evadir bloqueos de la AAP',
    'evd.targets': 'Objetivos', 'evd.target_ph': 'host / IP (ej: 10.0.0.5)', 'evd.lab_only': 'Solo objetivos del lab (allowlist).',
    'evd.scope_err': 'objetivo fuera de alcance',
    'evd.orch_subtitle': 'Flujo activo: pipeline de SQL Injection (emulación de ataque en vivo)',
    'evd.run_pipeline': 'EJECUTAR PIPELINE', 'evd.running': 'EJECUTANDO…',
    'evd.new_take': 'NUEVA TOMA', 'evd.preparing_take': 'PREPARANDO…',
    'evd.st_completed': 'COMPLETADO', 'evd.st_running': 'EJECUTANDO', 'evd.st_idle': 'INACTIVO', 'evd.st_blocked': 'PIPELINE FAIL',
    'evd.legend_title': 'Leyenda de colores del flujo',
    'evd.legend_recon': 'Recon y Descubrimiento', 'evd.legend_vuln': 'Verificación de Vuln', 'evd.legend_payload': 'Montaje de Payload',
    'evd.legend_exploit': 'Explotación Activa', 'evd.legend_final': 'Exfil y Final',
    'evd.feed_title': 'Feed de telemetría en vivo', 'evd.feed_empty': '// sin eventos — haz clic en EJECUTAR PIPELINE',
    'evd.records_exfil': 'registros exfiltrados', 'evd.secrets': 'secretos',
    'evd.see_postexploit': 've a la pestaña Post-Exploit para el loot completo',
    'evd.pe_inside': 'Estás dentro.',
    'evd.pe_desc': 'Elige las acciones de post-explotación — se ejecutan de verdad contra el lab (PIX real, volcado de datos, extracción de secretos).',
    'evd.pe_console': 'Post-Exploit Console · sesión activa', 'evd.pe_inside_tag': 'dentro del sistema',
    'evd.pe_report_title': 'Informe de lo que fue robado',
    'evd.col_name': 'Nombre', 'evd.col_cpf': 'CPF', 'evd.col_pass': 'Contraseña', 'evd.col_balance': 'Saldo', 'evd.col_bank': 'Banco', 'evd.col_pixkey': 'Clave PIX',
    'evd.col_mfa': 'MFA', 'evd.mfa_on': 'protegida', 'evd.mfa_off': 'sin MFA',
    'evd.reveal': 'revelar', 'evd.mask': 'enmascarar', 'evd.refresh': 'actualizar',
    'evd.esc_fail_title': 'PIPELINE FAIL',
    'evd.esc_blocked_msg': 'la pipeline falló al inicio. Escala los agentes a otras IPs:',
    'evd.esc_change_ip': 'Cambiar IP', 'evd.esc_escalate': 'Escalar agentes',
    'evd.esc_blocked': 'BLOQUEADO', 'evd.esc_ok': 'OK',
    'evd.esc_contained': '🛡️ CONTENIDO',
    'evd.agent_attack_failed': 'FAIL · ATAQUE CONTENIDO',
    'evd.swarm_title': 'Enjambre de agentes reales · Jobs de Kubernetes',
    'evd.swarm_title_docker': 'Enjambre de agentes reales · contenedores efímeros',
    'evd.pods': 'pods',
    'evd.agents': 'agentes',
    'evd.esc_real_hint': 'cada agente escalado es un Pod real de Kubernetes (Job efímero) — no es una animación',
    'evd.esc_swarm_size': 'Tamaño del enjambre',
    'evd.pod_ticker_title': 'Eventos del clúster (en vivo)',
    'evd.pod_stat_pending': 'Pendientes',
    'evd.pod_stat_running': 'En ejecución',
    'evd.pod_stat_succeeded': 'Completados',
    'evd.pod_stat_failed': 'Fallaron',
    'evd.pod_stopped_at': 'se detuvo en',
    'evd.pod_reached': 'llegó hasta',
    'evd.pod_reaped': 'pod recogido',
    'evd.pod_no_outcome': 'sin desenlace',
    'evd.pod_no_stage': 'no inició ninguna etapa',
    'evd.swarm_report_title': 'Informe de la ronda',
    'evd.swarm_rerun': 'Ejecutar enjambre',
    'evd.swarm_close': 'Cerrar panel',
    'evd.esc_err_cooldown': 'Espera el cooldown del backend:',
    'evd.esc_err_capacity': 'Límite de agentes simultáneos alcanzado — espera a que termine la ronda actual.',
    'evd.esc_err_forbidden': 'Sesión o token del operador inválido — escalada rechazada.',
    'evd.esc_err_unavailable': 'Orquestación de agentes no disponible (sin Kubernetes ni Docker).',
    'evd.esc_err_generic': 'Error al escalar:',
  },
  en: {
    'evd.subtitle': 'RECON_SUITE · lab only · synthetic data',
    'evd.internet': 'internet', 'evd.internal': 'internal',
    'evd.telemetry_live': 'telemetry live', 'evd.offline': 'offline',
    'evd.tab_control': 'Control Panel', 'evd.tab_orchestrator': 'Attack Orchestrator', 'evd.tab_postexploit': 'Post-Exploit',
    'evd.maximize': 'Maximize', 'evd.restore': 'Restore (Esc)',
    'evd.footer': 'EvilDog runs only against the DogBank lab services · educational / EBC use',
    'evd.rotate_ip': 'Rotate IP', 'evd.source_ip': 'Source IP',
    'evd.rotate_hint': 'Generates a new source IP (X-Forwarded-For) to evade AAP IP blocks',
    'evd.targets': 'Targets', 'evd.target_ph': 'host / IP (e.g. 10.0.0.5)', 'evd.lab_only': 'Lab targets only (allowlist).',
    'evd.scope_err': 'target out of scope',
    'evd.orch_subtitle': 'Active Flow: SQL Injection pipeline (live attack emulation)',
    'evd.run_pipeline': 'RUN PIPELINE', 'evd.running': 'RUNNING…',
    'evd.new_take': 'NEW TAKE', 'evd.preparing_take': 'PREPARING…',
    'evd.st_completed': 'COMPLETED', 'evd.st_running': 'RUNNING', 'evd.st_idle': 'IDLE', 'evd.st_blocked': 'PIPELINE FAIL',
    'evd.legend_title': 'Flow Color Legend',
    'evd.legend_recon': 'Recon & Discovery', 'evd.legend_vuln': 'Vulnerability Check', 'evd.legend_payload': 'Payload Structuring',
    'evd.legend_exploit': 'Active Exploit', 'evd.legend_final': 'Exfil & Final',
    'evd.feed_title': 'Live Telemetry Feed', 'evd.feed_empty': '// no events — click RUN PIPELINE',
    'evd.records_exfil': 'records exfiltrated', 'evd.secrets': 'secrets',
    'evd.see_postexploit': 'see the Post-Exploit tab for full loot',
    'evd.pe_inside': "You're in.",
    'evd.pe_desc': 'Pick post-exploitation actions — they really run against the lab (real PIX, data dump, secret extraction).',
    'evd.pe_console': 'Post-Exploit Console · active session', 'evd.pe_inside_tag': 'inside the system',
    'evd.pe_report_title': 'Report of what was stolen',
    'evd.col_name': 'Name', 'evd.col_cpf': 'CPF', 'evd.col_pass': 'Password', 'evd.col_balance': 'Balance', 'evd.col_bank': 'Bank', 'evd.col_pixkey': 'PIX key',
    'evd.col_mfa': 'MFA', 'evd.mfa_on': 'protected', 'evd.mfa_off': 'no MFA',
    'evd.reveal': 'reveal', 'evd.mask': 'mask', 'evd.refresh': 'refresh',
    'evd.esc_fail_title': 'PIPELINE FAIL',
    'evd.esc_blocked_msg': 'the pipeline failed at the start. Escalate agents to other IPs:',
    'evd.esc_change_ip': 'Change IP', 'evd.esc_escalate': 'Escalate agents',
    'evd.esc_blocked': 'BLOCKED', 'evd.esc_ok': 'OK',
    'evd.esc_contained': '🛡️ CONTAINED',
    'evd.agent_attack_failed': 'FAIL · ATTACK CONTAINED',
    'evd.swarm_title': 'Real agent swarm · Kubernetes Jobs',
    'evd.swarm_title_docker': 'Real agent swarm · ephemeral containers',
    'evd.pods': 'pods',
    'evd.agents': 'agents',
    'evd.esc_real_hint': 'each escalated agent is a real Kubernetes Pod (ephemeral Job) — not an animation',
    'evd.esc_swarm_size': 'Swarm size',
    'evd.pod_ticker_title': 'Cluster events (live)',
    'evd.pod_stat_pending': 'Pending',
    'evd.pod_stat_running': 'Running',
    'evd.pod_stat_succeeded': 'Succeeded',
    'evd.pod_stat_failed': 'Failed',
    'evd.pod_stopped_at': 'stopped at',
    'evd.pod_reached': 'reached',
    'evd.pod_reaped': 'pod reaped',
    'evd.pod_no_outcome': 'no outcome',
    'evd.pod_no_stage': 'no stage started',
    'evd.swarm_report_title': 'Round report',
    'evd.swarm_rerun': 'Run swarm',
    'evd.swarm_close': 'Close panel',
    'evd.esc_err_cooldown': 'Wait for the backend cooldown:',
    'evd.esc_err_capacity': 'Max concurrent agents reached — wait for the current round to finish.',
    'evd.esc_err_forbidden': 'Invalid operator session or token — escalation refused.',
    'evd.esc_err_unavailable': 'Agent orchestration unavailable (no Kubernetes, no Docker).',
    'evd.esc_err_generic': 'Escalate failed:',
  },
  it: {
    'evd.subtitle': 'RECON_SUITE · solo lab · dati sintetici',
    'evd.internet': 'internet', 'evd.internal': 'interno',
    'evd.telemetry_live': 'telemetria dal vivo', 'evd.offline': 'offline',
    'evd.tab_control': 'Pannello', 'evd.tab_orchestrator': 'Orchestratore', 'evd.tab_postexploit': 'Post-Exploit',
    'evd.maximize': 'Massimizza', 'evd.restore': 'Ripristina (Esc)',
    'evd.footer': 'EvilDog opera solo contro i servizi del laboratorio DogBank · uso educativo / EBC',
    'evd.rotate_ip': 'Ruota IP', 'evd.source_ip': 'IP di origine',
    'evd.rotate_hint': 'Genera un nuovo IP di origine (X-Forwarded-For) per eludere i blocchi dell\'AAP',
    'evd.targets': 'Obiettivi', 'evd.target_ph': 'host / IP (es: 10.0.0.5)', 'evd.lab_only': 'Solo obiettivi del lab (allowlist).',
    'evd.scope_err': 'obiettivo fuori ambito',
    'evd.orch_subtitle': 'Flusso attivo: pipeline di SQL Injection (emulazione di attacco dal vivo)',
    'evd.run_pipeline': 'ESEGUI PIPELINE', 'evd.running': 'IN ESECUZIONE…',
    'evd.new_take': 'NUOVO TAKE', 'evd.preparing_take': 'PREPARAZIONE…',
    'evd.st_completed': 'COMPLETATO', 'evd.st_running': 'IN ESECUZIONE', 'evd.st_idle': 'INATTIVO', 'evd.st_blocked': 'PIPELINE FAIL',
    'evd.legend_title': 'Legenda colori del flusso',
    'evd.legend_recon': 'Recon e Scoperta', 'evd.legend_vuln': 'Verifica Vuln', 'evd.legend_payload': 'Costruzione Payload',
    'evd.legend_exploit': 'Exploit Attivo', 'evd.legend_final': 'Exfil e Finale',
    'evd.feed_title': 'Feed di telemetria dal vivo', 'evd.feed_empty': '// nessun evento — clicca ESEGUI PIPELINE',
    'evd.records_exfil': 'record esfiltrati', 'evd.secrets': 'segreti',
    'evd.see_postexploit': 'vai alla scheda Post-Exploit per il loot completo',
    'evd.pe_inside': 'Sei dentro.',
    'evd.pe_desc': 'Scegli le azioni di post-exploit — vengono eseguite davvero contro il lab (PIX reale, dump dei dati, estrazione di segreti).',
    'evd.pe_console': 'Post-Exploit Console · sessione attiva', 'evd.pe_inside_tag': 'dentro il sistema',
    'evd.pe_report_title': 'Report di ciò che è stato rubato',
    'evd.col_name': 'Nome', 'evd.col_cpf': 'CPF', 'evd.col_pass': 'Password', 'evd.col_balance': 'Saldo', 'evd.col_bank': 'Banca', 'evd.col_pixkey': 'Chiave PIX',
    'evd.col_mfa': 'MFA', 'evd.mfa_on': 'protetta', 'evd.mfa_off': 'senza MFA',
    'evd.reveal': 'rivela', 'evd.mask': 'maschera', 'evd.refresh': 'aggiorna',
    'evd.esc_fail_title': 'PIPELINE FAIL',
    'evd.esc_blocked_msg': 'la pipeline è fallita all\'inizio. Scala gli agenti verso altri IP:',
    'evd.esc_change_ip': 'Cambia IP', 'evd.esc_escalate': 'Scala agenti',
    'evd.esc_blocked': 'BLOCCATO', 'evd.esc_ok': 'OK',
    'evd.esc_contained': '🛡️ CONTENUTO',
    'evd.agent_attack_failed': 'FAIL · ATTACCO CONTENUTO',
    'evd.swarm_title': 'Sciame di agenti reali · Job Kubernetes',
    'evd.swarm_title_docker': 'Sciame di agenti reali · container effimeri',
    'evd.pods': 'pod',
    'evd.agents': 'agenti',
    'evd.esc_real_hint': 'ogni agente scalato è un Pod Kubernetes reale (Job effimero) — non è un\'animazione',
    'evd.esc_swarm_size': 'Dimensione dello sciame',
    'evd.pod_ticker_title': 'Eventi del cluster (dal vivo)',
    'evd.pod_stat_pending': 'In attesa',
    'evd.pod_stat_running': 'In esecuzione',
    'evd.pod_stat_succeeded': 'Completati',
    'evd.pod_stat_failed': 'Falliti',
    'evd.pod_stopped_at': 'fermato a',
    'evd.pod_reached': 'arrivato a',
    'evd.pod_reaped': 'pod raccolto',
    'evd.pod_no_outcome': 'nessun esito',
    'evd.pod_no_stage': 'nessuna fase avviata',
    'evd.swarm_report_title': 'Report del round',
    'evd.swarm_rerun': 'Esegui sciame',
    'evd.swarm_close': 'Chiudi pannello',
    'evd.esc_err_cooldown': 'Attendi il cooldown del backend:',
    'evd.esc_err_capacity': 'Limite di agenti simultanei raggiunto — attendi la fine del round attuale.',
    'evd.esc_err_forbidden': 'Sessione o token operatore non valido — escalation rifiutata.',
    'evd.esc_err_unavailable': 'Orchestrazione agenti non disponibile (né Kubernetes né Docker).',
    'evd.esc_err_generic': 'Errore nello scalare:',
  },
};

export default evildog;
